var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0888 8.23226C11.0888 8.64647 11.4246 8.98226 11.8388 8.98226H18.5888C19.003 8.98226 19.3388 8.64647 19.3388 8.23226C19.3388 7.81804 19.003 7.48226 18.5888 7.48226H12.5888V1.48226C12.5888 1.06804 12.253 0.732256 11.8388 0.732256C11.4246 0.732256 11.0888 1.06804 11.0888 1.48226V8.23226ZM12.3691 8.76259L17.6724 3.45929L16.6118 2.39863L11.3085 7.70193L12.3691 8.76259Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0533 11.7677C9.0533 11.3535 8.71751 11.0177 8.3033 11.0177H1.5533C1.13909 11.0177 0.803301 11.3535 0.803301 11.7677C0.803301 12.182 1.13909 12.5177 1.5533 12.5177H7.5533V18.5177C7.5533 18.932 7.88909 19.2677 8.3033 19.2677C8.71751 19.2677 9.0533 18.932 9.0533 18.5177V11.7677ZM7.77297 11.2374L2.46967 16.5407L3.53033 17.6014L8.83363 12.2981L7.77297 11.2374Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackSmall);
export default __webpack_public_path__ + "static/media/arrow-back-small.14da1cc5384f03b8c5a2eff5f7bf6182.svg";
export { ForwardRef as ReactComponent };